import { render } from "./QiniuUp.vue?vue&type=template&id=322d2848"
import script from "./QiniuUp.vue?vue&type=script&lang=js"
export * from "./QiniuUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__